"use client";

import { backendClient } from "@/lib/backend-api";
import { useQuery } from "@tanstack/react-query";

export const featureFlagsQueryKey = ["feature-flags"] as const;

export const useFeatureFlags = () =>
  useQuery({
    queryKey: featureFlagsQueryKey,
    queryFn: () => backendClient.shop.getFeatureFlags(),
    staleTime: 10_000,
  });
